<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <SmallSquare content='查看二维码扫码明细记录；默认显示近30天内的扫码记录，最多储存180天内的扫码记录；扫码明细记录非实时显示，记录在扫码一分钟后显示。' :padding='false'></SmallSquare>
      <a-form ref='form' :model='search' class="m-t-20" :initialValues="search"
        :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="扫码时间" name='time'>
              <a-range-picker valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD  ' @change="changTime"    v-model:value="search.time"  />
        </a-form-item>
        <a-form-item label="扫码结果" name='keyword' >
          <a-select v-model:value="search.scan_count" @change="inputSelect" style='width:180px' placeholder="请选择扫码结果">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">首次</a-select-option>
            <!-- <a-select-option :value="2">非中奖</a-select-option> -->
            <a-select-option :value="2">重复</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="流水号" name='serial_sn'>
          <a-input v-model:value="search.serial_sn" style='width:250px' placeholder="请输入流水号进行搜索" />
        </a-form-item>
        <a-form-item label="所在地区" name='name'>
          <selectCity v-on:citychange='citychange' placeholder="所在地区" />
        </a-form-item>
        <!-- <normalBatchs v-model:value="search.batch_sn" type='select' /> -->
         <a-form-item label="批次" name='batch_sn'>
          <a-input v-model:value="search.batch_sn" style='width:250px' placeholder="请输入批次号进行搜索"></a-input>
        </a-form-item>
        <a-form-item label="码ID" name='code' >
          <a-input class='m-b-10' v-model:value="search.code" style='width:250px' placeholder="请输入码ID进行搜索"></a-input>
        </a-form-item>
        <a-form-item label="活动" name="">
          <a-input v-model:value='search.activity_name' style='width:200px' readonly placeholder="请选择活动"></a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click='activityVisible=true'>选择</a-button>
          <a-button class="m-l-5" @click='search.activity_name="";search.activity_id=""' >重置</a-button>
        </a-form-item>
        <a-form-item label="会员信息" name='member_keyword'>
          <a-input v-model:value="search.member_keyword" style='width:250px' placeholder="请输入昵称/ID进行搜索" />
        </a-form-item>
        <a-form-item label="商品名称" name='product_keyword'>
          <a-input v-model:value="search.product_keyword" style='width:250px' placeholder="请输入商品名称进行搜索" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
          <a-button v-has:qrcodeDataLogExport="exportTable" class='m-r-10'>导出</a-button>
        </a-form-item>
      </a-form>
      <div class='m-t-20'>
        <div class="m-b-10">扫码人数：{{scanNum || 0}}</div>
        <a-table :pagination='false' :loading='listLoading' bordered  :columns='columns'  :data-source='list' class="tableFixBox" :scroll="{ x: 'max-content'}">
           <template v-slot:product_name="{record}">
            <a-card-meta v-if="record.product_name">
              <template #avatar>
                <img :src="info.picdomain+'/'+record.product_img" alt="" style="width:50px;" class="width-50 height-50">
              </template>
              <template #description>
                <p class="s_c333">{{record.product_name}}</p>
              </template>
            </a-card-meta>
            <p v-else>-</p>
          </template>
           <template v-slot:position="{record}">
             <p>{{record.area}}</p>
           </template>
          <template v-slot:member="{ record }">
               <div class="s_flex_ali" v-if="record.member_id!=0">
              <img class="width-50 height-50 m-r-15"  :src="record.member_img ? record.member_img : ''" alt="" />
              <div>
                <p>{{record.member_name || '-'}}</p>
                <p>ID：{{record.member_id}}</p>
              </div>
            </div>
            <div v-else >
              <img class="width-50 height-50 m-r-15" src="@/assets/images/normal.png" alt="">
            </div>
          </template>
          <template v-slot:code_sn="{ record }">
            <p>{{record.product_code}}</p>
            （{{record.code_sn}}）
          </template>
          <template v-slot:scanStore="{ record }">
            <p>{{record.belong_channel_name}}</p>
              {{record.belong_channel_code}}
          </template>
          
          <template v-slot:action="{ record }">
            <a href="javascript:;" v-has:qrcodeDataLogDetail="()=>{showEdit=true;scan_id=record.id}">详情</a>
          </template>
        </a-table>
        <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper
          :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
          @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
      </div>
    </a-card>
    <a-modal  :keyboard="false" title="扫码明细详情" centered v-model:visible="showEdit" :width='1300' :footer="null" destroyOnClose>
      <scanMore type='scan' :id='scan_id'></scanMore>
    </a-modal>
    <!-- 活动弹窗 -->
    <a-modal  :keyboard="false" v-model:visible="activityVisible" centered style="width:700px" :width='1300'>
      <selectActivity v-on:select="activitySelect" :checkout='false' />
    </a-modal>
  </a-layout>
</template>
<script>
  import { reactive, ref, toRefs, onMounted, inject } from "vue";
  import { iscode } from "@/utils/app";
  import { scan_logs,scanLogsExport,scan_logsScanNum } from '@/api/qrcode'
  import scanMore from './detail'
  import { message } from 'ant-design-vue';
  import store from '@/store'
  const def = {
    page: 1,
    limit: 10,
    start_time: "",
    end_time: "",
    batch_sn: "",
    remarks: "",
    serial_sn:'',
    code:'',
    activity_id:'',
    product_keyword:'',
    province_id:'',
    city_id:'',
    district_id:'',
    member_keyword:'',
    scan_count:''
  };
  export default {
    name: "integralDetail",
    props: {
      type: String,
    },
    components: { scanMore },
    setup(props) {
      const state = reactive({
        vipList: [],
        listLoading: false,
        total: 0,
        showEdit: false,
        scan_id:'',
        activityVisible:false,
        scanNum:0
      });
      let list = ref();

      let columns = [
        {
          title: "码ID",
          dataIndex: "code_sn",
          key: "code_sn",
          width:200,
          slots: { customRender: "code_sn" },
        },
        {
          title: "会员信息",
          dataIndex: "member",
          key: "member",
          slots: { customRender: "member" },
        },
        {
          title: "扫码结果",
          dataIndex: "scan_num",
          key: "scan_num",
          customRender:({record})=>{
              return record.scan_num==1?'首次':`第${record.scan_num}次`
          } 
        },
        {
          title: "商品名称",
          dataIndex: "product_name",
          key: "product_name",
          slots: { customRender: "product_name" },
          width:300
        },
        {
          title: "扫码活动",
          dataIndex: "activity_name",
          key: "activity_name",
          customRender:({record})=>{
              return record.activity_name?record.activity_name:'-'
          } 
        },
        {
          title: "扫码时间",
          key: "created_time",
          dataIndex: "created_time",
          width:120
        },
        {
          title: "扫码地区",
          dataIndex: "area",
          key: "area",
          width:130,
          slots: { customRender: "position" },
          // customRender:({record})=>{
          //     return record.city+record.city+record.district+record.
          // } 
        },
       {
          title: "扫码门店/经销商",
          dataIndex: "area",
          key: "area",
          slots: { customRender: "scanStore" },
        },
     
        {
          title: "操作",
          dataIndex: "action",
          key: "action",
          fixed: 'right',
          width:100,
          slots: { customRender: "action" },
        },
      ];
      const initData = async (values) => {
        state.listLoading = true;
        list.value=[]
        let res = await scan_logs(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          list.value = res.data;
          state.total = res.meta.total;
        }
        state.listLoading = false;
      };
      const search = ref({...def});
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
        getScanNum()
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      const inputSelect = (e) => {
        search.value.keyword = "";
      };
      const activitySelect = (data) => {
        search.value.activity_id = data.activity_id;
        search.value.activity_name = data.activity_name;
        state.activityVisible = false;
      };
      const citychange = (e,s) =>{
        search.value.province_id = e[0]
        search.value.city_id = e[1]
        search.value.district_id = e[2]
      }
    const $moment=inject('momentTime')
      onMounted(() => {
           var end_time = $moment()
          .subtract(0, "d")
          .format("YYYY-MM-DD");
      var  start_time = $moment()
          .subtract(29, "d")
          .format("YYYY-MM-DD");
      search.value.time=[start_time,end_time]
          search.value.start_time =start_time
        search.value.end_time = end_time
        initData(search.value);
        getScanNum()
      });
      // 导出
      const exportTable=async ()=>{
         const hide = message.loading('正在加载中...', 0);
         var json=JSON.parse(JSON.stringify(search.value))
        delete json.page;
        delete json.limit;
        let result=await  scanLogsExport(json).then(res=>res.data).catch(error=>error)
        setTimeout(hide);
          if(iscode(result,true)){
            window.open(result.data.url)
         }
      }
      //扫码人数
      const getScanNum = async function(){
         let res = await scan_logsScanNum({...search.value}).then(res=>res.data);
         if(iscode(res)){
            state.scanNum = res.data.scan_num || 0;
         }else{
           message.error(res.msg)
         }
      }

      return {
           info: store.state.user.info,
        ...toRefs(state),
        search,
        list,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        changTime,
        inputSelect,
        activitySelect,
        citychange,
        exportTable,
        getScanNum
      };
    },
  };
</script>